import { ReactElement } from 'react'
import AppHeader from './partials/AppHeader'
import { ConsultantSessionBanner } from './partials/ConsultantSessionBanner'
import {
    LayoutRSC as Layout,
    LayoutContentPaneRSC as LayoutContentPane,
    LayoutContentPaneType,
    LayoutTopPaneRSC as LayoutTopPane,
    LayoutTopPaneType,
    RetainBehaviorModifier,
    RetainSizeModifier,
} from '@lib-components'
import { HiddenWhenNotConsultant } from '@/components/hidden-when/HiddenWhenNotConsultant'

interface AppLayoutProps {
    children: ReactElement | ReactElement[]
}

const AppLayout = ({ children }: AppLayoutProps): ReactElement => {
    return (
        <Layout retainSize={RetainSizeModifier.FULL_WIDTH}>
            <LayoutTopPane paneType={LayoutTopPaneType.TOP_PANE_FIXED}>
                <AppHeader />
            </LayoutTopPane>
            <LayoutContentPane
                fillAvailableHeight={false}
                paneType={LayoutContentPaneType.CONTENT}
                customRetainBehaviorModifier={RetainBehaviorModifier.PADDING_INVERTED}
            >
                <>
                    <HiddenWhenNotConsultant>
                        <ConsultantSessionBanner />
                    </HiddenWhenNotConsultant>
                    {children}
                </>
            </LayoutContentPane>
        </Layout>
    )
}

export default AppLayout
